import { Box } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { callAPIInterface } from "../constants";
import MiniAppHeading from "./MiniAppHeading";
import List from "./List";
import { useSession } from "../../hooks/useSession";
import BannerTile from "./BannerTile";
import Grid from "./Grid";
import DynamicBannerTile from "./DynamicBannerTile";
import Carousel from "./Carousel";
import CollectionDetailDialog from "./CollectionDetailDialog";
import { setCollectionData } from "../../redux/actions";

const noTitleIncludedType = ["grid"];

function CollectionList({ isFromMainList }) {
  const dispatch = useDispatch();
  const { session } = useSession();
  const collectionData = useSelector((state) => state.common.collectionData);

  const [isOpenDetailPage, setIsOpenDetailPage] = useState(false);
  const [selectedCollectionId, setSelectedCollectionId] = useState(null);

  const handleGetCollection = async () => {
    try {
      const response = await callAPIInterface(
        "POST",
        "/manage-app/apps/collection",
        JSON.stringify({
          restricted_countries: {
            not_contains: session?.account?.account?.country,
          },
        })
      );
      dispatch(setCollectionData(response?.data));
    } catch (err) {
      console.log("Error while fetching collection list:", err);
    }
  };

  useEffect(() => {
    session && handleGetCollection();
  }, [session]);

  const renderList = (data, idx, dataLength) => {
    return (
      <Box padding="0 15px">
        <List data={data} idx={idx} dataLength={dataLength} />
      </Box>
    );
  };

  const renderComponent = useCallback(
    ({ collectionType, collectionData, title, idx, collectionId }) => {
      switch (collectionType.toLowerCase()) {
        case "list":
          return collectionData?.map((data, idx) => {
            return renderList(data, idx, collectionData?.length);
          });
        case "banner_tile":
          return <BannerTile collectionData={collectionData} />;
        case "dynamic_banner_tile":
          return <DynamicBannerTile collectionData={collectionData} />;
        case "grid":
          return (
            <Grid
              collectionData={collectionData}
              title={title}
              idx={idx}
              collectionId={collectionId}
            />
          );
        case "carousel":
          return <Carousel collectionData={collectionData} />;

        default:
          return collectionData?.map((data, idx) => {
            return renderList(data, idx, collectionData?.length);
          });
      }
    },
    []
  );

  const handleOpenDetailPage = (collection) => {
    setIsOpenDetailPage(true);
    setSelectedCollectionId(collection?.collection_id);
  };

  return (
    <Box className="collection-list">
      {collectionData?.map((collection, idx) => {
        return (
          <Box key={collection.collection_id || idx}>
            {isFromMainList &&
              !noTitleIncludedType.includes(
                collection?.asset_view_type?.toLowerCase()
              ) && (
                <MiniAppHeading
                  title={collection?.name}
                  handleAction={() => {
                    handleOpenDetailPage(collection);
                  }}
                />
              )}
            {renderComponent({
              collectionType: collection?.asset_view_type,
              collectionData: collection?.app_list,
              title: collection?.name,
              collectionId: collection?.collection_id,
              idx,
            })}
          </Box>
        );
      })}
      {isOpenDetailPage && (
        <CollectionDetailDialog
          isOpen={isOpenDetailPage}
          setIsOpen={setIsOpenDetailPage}
          collectionName={
            collectionData?.find(
              (c) => c.collection_id === selectedCollectionId
            )?.name
          }
          collectionId={selectedCollectionId}
        />
      )}
    </Box>
  );
}

export default CollectionList;
